import moment, { Moment } from "moment";
import type { IProduct } from "types/product";

export const getProductVariantAvailableDays = (
    product: IProduct,
    enforceAvailableUntil = false,
    defaultDeliveryWindow = 0,
): {
    from: Moment;
    until: Moment | null;
} => {
    const momentAvailableFrom = product.available_from ? moment(product.available_from) : moment();
    const momentAvailableTo = product.available_until ? moment(product.available_until) : null;
    const availableDateDiff = (momentAvailableTo ?? moment()).utc().diff(momentAvailableFrom.utc(), "days");

    const dates = {
        from: momentAvailableFrom,
        until: momentAvailableTo,
    };

    if (enforceAvailableUntil && availableDateDiff < defaultDeliveryWindow) {
        dates.until = momentAvailableFrom.clone().utc().add(defaultDeliveryWindow, "days");
    }

    return dates;
};
